import { useState } from "react";

import { Authorization } from "@asd/customer-portal-api";
import { Box } from "@mui/material";
import { Allotment } from "allotment";

import Authorizations from "./Authorizations";
import Checks from "./Checks";

const BudgetData = () => {
  const [selectedAuthorizations, setSelectedAuthorizations] = useState<Authorization[]>([]);

  const isChecksVisible = !!selectedAuthorizations.length;

  return (
    <Box
      height="100%"
      position="relative"
      sx={[
        {
          "& .split-view-container": {
            overflow: "auto",
          },
        },
        isChecksVisible && {
          "& .budgetDetailSplit > .sash-container .sash::after": {
            content: "'\\21F3'",
            position: "absolute",
            height: "calc(var(--sash-hover-size) * 2)",
            width: (theme) => theme.spacing(2),
            left: "50%",
            top: "calc(50% - var(--sash-hover-size) + 1px)",
            transform: "translateX(-50%)",
            fontSize: "x-large",
            lineHeight: "6px",
          },
        },
      ]}
      width="100%"
    >
      <Allotment className="budgetDetailSplit" minSize={15} vertical>
        <Authorizations setSelectedAuthorizations={setSelectedAuthorizations} />
        <Allotment.Pane preferredSize="70%" visible={isChecksVisible}>
          <Checks selectedAuthorizations={selectedAuthorizations} />
        </Allotment.Pane>
      </Allotment>
    </Box>
  );
};

export default BudgetData;
